// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\pages\\home\\EquipmentSection\\index.ts"
);
import.meta.hot.lastModified = "1757171103296.608";
}
// REMIX HMR END

export { EquipmentSection } from "./EquipmentSection";
export type { Equipment } from "./EquipmentSection";